// extracted by mini-css-extract-plugin
export default {"wrapper":"Winners_wrapper__fRti8","item":"Winners_item__PMx5H","avatarBlock":"Winners_avatarBlock__Rhui+","star":"Winners_star__bHZPj","name":"Winners_name__CuBIz"};